<template>
    <div v-for="(item, index) in items" :key="index">
        <a class="services-landing__third-level-item" :href="item.url">
            {{ item.title }}
        </a>
    </div>
</template>

<script>

export default {
    props: ["items"],
    components: {
    },
    data() {
        return {
            active: null
        }
    },
    methods: {

    }

}
</script>

